var _filter, _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 88,
    viewBox: "0 0 144 88",
    width: 144,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "theme-dark-a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 96,
    width: 152,
    x: 4,
    y: 14
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "erode",
    radius: 3,
    result: "effect1_dropShadow_9973_74"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9973_74"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "erode",
    radius: 4,
    result: "effect2_dropShadow_9973_74"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_9973_74",
    mode: "normal",
    result: "effect2_dropShadow_9973_74"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9973_74",
    mode: "normal",
    result: "shape"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "theme-dark-b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h144v88h-144z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#theme-dark-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h144v88h-144z",
    fill: "#3a3a3b"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#theme-dark-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 28c0-6.6274 5.3726-12 12-12h116v72h-128z",
    fill: "#18181b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 16.5h115.5v71h-127v-59.5c0-6.3513 5.1487-11.5 11.5-11.5z",
    stroke: "#464649"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3a3a3b"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 20,
    rx: 4,
    width: 20,
    x: 28,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    rx: 4,
    width: 72,
    x: 58,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    height: 20,
    rx: 4,
    width: 20,
    x: 28,
    y: 56
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58 65c0-2.2091 1.7909-4 4-4h48c2.209 0 4 1.7909 4 4v2c0 2.2091-1.791 4-4 4h-48c-2.2091 0-4-1.7909-4-4z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.7d985b807dfd5f8442bac10dcfc1df1b.svg";
export { ForwardRef as ReactComponent };